module.exports = __webpack_public_path__ + "static/media/info.67734597.svg";